// 测面滑动菜单效果
const SHOW_MENU = true
const HIDE_MENU = false

const search = {
  state: {
    isShow: false,
    detail: {
      title: 'title : by 把苹果咬哭'
    }
  },
  mutations: {
    showSearch (state, obj) {
      state.detail = state.detail
      state.isShow = SHOW_MENU
    },
    hideSearch (state) {
      // state.detail = {}
      state.isShow = HIDE_MENU
    }
  },
  actions: {
    showSearch ({commit}, obj) {
      commit('showSearch', obj)
    },
    hideSearch ({commit}) {
      commit('hideSearch')
    }
  },
  getters: {
    getSearchShow: state => state.isShow
    // getShowMenuInfo: state => state.detail
  }
}
export default search



// WEBPACK FOOTER //
// ./src/store/modules/search.js